import { render, staticRenderFns } from "./KanbanColumn.vue?vue&type=template&id=25380e88&scoped=true&"
import script from "./KanbanColumn.vue?vue&type=script&lang=js&"
export * from "./KanbanColumn.vue?vue&type=script&lang=js&"
import style0 from "./KanbanColumn.vue?vue&type=style&index=0&id=25380e88&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25380e88",
  null
  
)

export default component.exports